export default __webpack_public_path__ + "static/media/17.78c11808.jpg";